import {useQuery} from "@tanstack/react-query";
import {getBillingInvoice} from "../../api/api";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {toast} from "react-toastify";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import RecordsNotFound from "../../components/RecordsNotFound";
import Paginator from "../../components/Paginator";
import PDF_Icon from "../../assets/images/file-icons/pdf.svg";

function BillingInvoiceTab() {
    const {refreshToken} = useContext(AuthContext)
    const [page, setPage] = useState(1);
    // const queryClient = useQueryClient();
    // const [businessLogo, setBusinessLogo] = useState('');

    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: ['billing-invoice', page],
        queryFn: () => getBillingInvoice(page),
        keepPreviousData : true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }),
    })

    // useEffect(() => {
    //     if (data && data.results[0] && data.results[0].business_logo) {
    //         setBusinessLogo(data.results[0].business_logo);
    //     }
    // }, [data]);

    // const businessInfomutation = useMutation({
    //     mutationFn: ({ formData, businessInfoId }) => addBusinessInfo({ formData, businessInfoId }),
    //     onSuccess: () => {
    //         toast.success('Profile picture updated successfully!');
    //         queryClient.invalidateQueries(['business-info']);
    //     },
    //     onError: (err) => {
    //         toast.error(`An error occurred! ${err?.response?.data?.detail}`);
    //     },
    // });

    // const handleFileChange = (e) => {
    //     const businessLogo = e.target.files[0];
    //     if (businessLogo) {
    //         setBusinessLogo(businessLogo);
    //         const formData = new FormData();
    //         formData.append('business_logo', businessLogo);
    //         businessInfomutation.mutate({
    //             formData: formData, businessInfoId: data.results[0].id
    //         });
    //     }
    // };

    return (
        <>
            {status === 'success' | error?.response?.status === 401 && (
                <div className="mt-3">
                    <div className="mb-3">
                        <h4 className="mb-1">Billing Invoices</h4>
                        <p className="text-muted mb-0">Download finalized invoices for each billing cycle.</p>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-centered mb-0">
                            <thead className="font-13 bg-light text-muted">
                            <tr>
                                <th>Invoice Number</th>
                                <th>Billing Period</th>
                                <th>Invoice Date</th>
                                <th>Amount Before Tax (Before Discount)</th>
                                <th>Credit Points Applied</th>
                                <th>Discount</th>
                                <th>Total Amount Before Tax</th>
                                <th>CGST</th>
                                <th>SGST</th>
                                <th>IGST</th>
                                <th>Total Amount After Tax</th>
                                <th>Status</th>
                                <th>Invoice</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data?.count > 0? data?.results?.map(inv => (
                                <tr key={inv.id}>
                                    <th>{inv.invoice_number}</th>
                                    <td>{inv.month}/{inv.year}</td>
                                    <td>{inv.invoice_date}</td>
                                    <td>{inv.total_amount_before_tax_before_discount}</td>
                                    <td>{inv.credits_applied}</td>
                                    <td>{inv.discount}</td>
                                    <td>{inv.total_amount_before_tax}</td>
                                    <td>{inv.cgst}</td>
                                    <td>{inv.sgst}</td>
                                    <td>{inv.igst}</td>
                                    <td>{inv.total_amount_after_tax}</td>
                                    <td>{inv.status==='PAID'?<span className="badge bg-success">{inv.status}</span>: <span className="badge bg-danger">{inv.status}</span>}</td>
                                    <td>
                                        {inv.invoice_file ? (
                                            <a
                                                href={inv.invoice_file}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                                            >
                                                <img
                                                    src={PDF_Icon}
                                                    alt="PDF"
                                                    width="20"
                                                    height="20"
                                                    style={{ cursor: "pointer" }}
                                                />
                                                <span>View PDF</span>
                                            </a>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                </tr>
                            )): <RecordsNotFound/>}
                            </tbody>
                        </table>
                        {status === 'success' && (
                            <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                        )}
                    </div>
                </div>
            )}

        </>
    );
}

export default BillingInvoiceTab;
